import { put, call, takeLatest } from 'redux-saga/effects';
import { notification } from 'antd';
// import ApiService from '../Services/ApiService';
// import AppActions from '../Stores/App/Actions';
import GradingMachineProcessActions, {
  GradingMachineProcessTypes
} from '../Stores/GradingMachineProcess/Actions';

// const getAppStore = state => state.app;

// eslint-disable-next-line import/prefer-default-export
export function* gradingMachineProcessFetchList() {
  try {
    yield put(GradingMachineProcessActions.gradingMachineProcessFetchListLoading(true));

    const result = [
      { proc_type: 'GRADING_MACHINE_LIST', icon: 'fa fa-cubes' },
      { proc_type: 'GRADING_MACHINE_EXCEL', icon: 'fa fa-file-excel-o' }
    ];
    yield put(GradingMachineProcessActions.gradingMachineProcessFetchListSuccess(result));
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(GradingMachineProcessActions.gradingMachineProcessFetchListLoading(false));
  }
}

export const saga = [
  takeLatest(
    GradingMachineProcessTypes.GRADING_MACHINE_PROCESS_FETCH_LIST,
    gradingMachineProcessFetchList
  )
];
